<template>
  <em class="fas fa-circle" v-bind:class="{
    'text-default': status === '',
    'text-danger': status === 'error',
    'text-warning': status === 'disabled',
    'text-success': status === 'created',
    'text-info': status === 'in_process'
  }"></em>
</template>

<script>
export default {
  name: "StpAccountStatusIcon",
  props: {
    status: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped></style>
